export default "__VITE_ASSET__CJjUBJjN__"